/* eslint-disable no-shadow */
// eslint-disable-next-line import/prefer-default-export
import { IFieldEntity } from 'core/utils/report.util';
import React from 'react';
import { OperatorTypes } from './report';

export enum FilterType {
  NumberInteger = 'NumberInteger',
  NumberDecimal = 'NumberDecimal',
  PRE_APPLIED = 'PRE_APPLIED',
  UserMultiSelect = 'UserMultiSelect',
  LSQMetadataMultiSelect = 'LSQMetadataMultiSelect',
  DateRange = 'DateRange',
  DRILLDOWN = 'DRILLDOWN',
  FILTER_ONLY = 'Filter_Only',
  CustomDefinedMultiSelect = 'CustomDefinedMultiSelect',
  CustomDefinedSingleSelect = 'CustomDefinedSingleSelect',
  LSQMetadataSingleSelect = 'LSQMetadataSingleSelect',
  MultiTextSearch = 'MultiTextSearch',
  FILTER = 'Filter',
  SET_FILTER = 'SET_FILTER',
  GroupMultiSelect = 'GroupMultiSelect',
  Hidden = 'Hidden',
  EmptyFilterType= '',
}

export enum ClickType {
  DRILLDOWN = 'DRILLDOWN',
  SET_FILTER = 'SET_FILTER',
}

export enum UserFilterPayloadType {
  All = 'ALL',
  In = 'IN',
  NotIn = 'NOTIN',
}

export enum SelectBulkAction {
  None = -1,
  SelectAll,
  RemoveAll,
}

export enum UserMultiSelectFilterKeyType {
  GroupUsers = 'GroupUsers',
}

export enum MaxLimitDesc {
  AppliedFilter = 'Maximum Limit of filters ({{Filter limit}}) have been reached',
  AppliedDimension = 'Maximum Limit of fields {{limit}} have been reached',
  DrilldownField = 'Maximum Limit of fields {{limit}} have been reached',
  Values = 'Maximum Limit of values {{limit}} have been reached',
}

export enum NumberOfFiltersApplied {
  AppliedFilters = 'All except ({{difference}})',
}

export const TaggedInputFilterPlaceholder = 'Type here and enter...';
export const TaggedInputRestrictedChars = "* These characters cannot be used: `   ;   \\   '   \"   >   <   ";
export const TaggedInputMaxLength = '* You cannot search for a string greater than 256 characters in length.';
export const TaggedInputMaxItem = '* You can search for max 15 strings at a time.';

export interface AccordGroup<T> {
  groupId: string;
  headerName: string;
  headerIcon: IFieldEntity;
  accordValues: T[];
  emptyStateText?: string;
  allItemsAddedMessage?: string;
}

export const GroupFilterId = 'Group-Filter-Id';

export const DEFAULT_OPTIONS_META = {
  Page: {
    PageIndex: 0,
    PageSize: 20,
  },
  SearchKey: '',
  Count: 0,
  HasNextPage: false,
};

export const NumberFilterTypes = [FilterType.NumberInteger, FilterType.NumberDecimal];
export const DefaultNumberFilterOperator = OperatorTypes.IS_NOT_NULL;
export const DefaultValueForNumberFilterOperators: Record<Exclude<OperatorTypes, OperatorTypes.IN>, any> = {
  [OperatorTypes.BETWEEN]: {
    From: 0,
    To: 0,
  },
  [OperatorTypes.IS_NULL]: {},
  [OperatorTypes.IS_NOT_NULL]: {},
  [OperatorTypes.EQ]: 0,
  [OperatorTypes.NOT_EQ]: 0,
  [OperatorTypes.LTE]: 0,
  [OperatorTypes.GTE]: 0,
};
export enum NumberFilterOperatorTypes {
  Absolute = 'Absolute',
}

export enum LinkedFilterSource {
  MainReport = 'MainReport',
  SubBuilder = 'SubBuilder',
}

export enum LinkedFilterOrigin {
  AppliedFilter = 'AppliedFilter',
  AppliedDimension = 'AppliedDimension',
}
